import { render } from "./GrabASnack.vue?vue&type=template&id=b80233b8"
import script from "./GrabASnack.vue?vue&type=script&setup=true&lang=js"
export * from "./GrabASnack.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/survey/GrabASnack.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b80233b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b80233b8', __exports__)) {
    console.log('reload')
    api.reload('b80233b8', __exports__)
  }
  
  module.hot.accept("./GrabASnack.vue?vue&type=template&id=b80233b8", () => {
    console.log('re-render')
    api.rerender('b80233b8', render)
  })

}


export default __exports__